import { PCTool } from './PCTool'
import { SHLine, GeomDataHolder } from '../ImportHelper'
import { endEventCreator, addPointCreator } from './EventCreator'

class CloudHLineTool extends PCTool {
    constructor (panogl) {
        super(panogl, SHLine, GeomDataHolder.HLine)
        this.type = 'HLine'
    }

    endDraw () {
        let dh = this.dh
        let pointNumber = dh.getPointLength()
        let isSuccessful = false
        if (pointNumber < 2) {
            dh.setStatus(GeomDataHolder.STATUS.BAD_COMPLETED)
        } else {
            isSuccessful = true
            dh.setStatus(GeomDataHolder.STATUS.COMPLETED)
        }
        this.throwEvent(endEventCreator(this.type, isSuccessful, this.dh))
    }

    addPoint (point) {
        console.log('dsdasdas')

        if (Array.isArray(point)) {
            this._points.push(point)

            let dh = this.dh
            let pointNumber = dh.getPointLength()

            console.log('dendjendhnehbh')

            if (pointNumber === 2) {
                this.endDraw()
            }

            this.update()
            this.throwEvent(addPointCreator(this.type, true, this.dh, point))
        } else {
            this.throwEvent(addPointCreator(this.type, false, this.dh, point))
        }
    }

    onPointsReceived (points) {
        let pt = points[0]
        this.addPoint(pt)
    }

    update () {
        let dh = this.dh
        dh.resetPoints()
        dh.setPoints(this._points.map(([lon, lat, alt]) => ({ lon, lat, alt })))
    }
}

export { CloudHLineTool }
